import {catchError, map, of, startWith, Subject, switchMap} from 'rxjs';
import {handleLoginSuccess} from '@/helper/login';
import {execObservableSteps} from '@/streams/utils';
import type {SupportConnectors} from '@/streams/wallet-connect';
import {createAccessWithWaletSteps} from '@/modules/components/connect-wallet/access-streams';

export function createActions(connector: SupportConnectors, isPop = false, isOauth = false, target = '') {
  const submitConnect$ = new Subject<Omit<SubmitParams, 'connector'>>();

  const connectState$ = submitConnect$.pipe(
    map((params) => ({...params, connector})),
    switchMap((submitParams) => {
      const {LG, referralCode = '', group = ''} = submitParams;
      const accessSteps = createAccessWithWaletSteps({connector, LG, referralCode, group});
      return execObservableSteps(accessSteps, submitParams).pipe(
        map(() => {
          handleLoginSuccess(isPop, isOauth, connector, target);
          return {loading: false};
        }),
        startWith({loading: true}),
        catchError(() => of({loading: false}))
      );
    })
  );

  return {
    submitConnect$,
    connectState$,
  };
}

type Scene = 'Login' | 'Register';

interface SubmitParams {
  scene: Scene;
  LG: any;
  referralCode: string;
  group: number | string;
  connector: SupportConnectors;
}
